import { render, staticRenderFns } from "./TopbarItalian.vue?vue&type=template&id=64d7d902"
import script from "./TopbarItalian.vue?vue&type=script&lang=js"
export * from "./TopbarItalian.vue?vue&type=script&lang=js"
import style0 from "./TopbarItalian.vue?vue&type=style&index=0&id=64d7d902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TopbarItalian.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports